import React from 'react';
import { member$, memberRefresh$ } from '../services/subjects';
import BaseComponent from '../components/BaseComponent';

export default function withMemberData(WrappedComponent) {
    return class extends BaseComponent {
        constructor(props) {
            super(props);
            this.state = {
                loading: true,
                loadedOnce: false,
            };
            this.subscription = null;
            this.loadMember = this.loadMember.bind(this);
        }

        componentDidMount() {
           this.loadMember();
        }

        loadMember() {
            this.subscriptions.forEach((subscription) => subscription?.unsubscribe());
            this.setState({loading: true});
            this.subscription = this.subscribe(member$, {
                next: (member) => {
                    this.setState({ ...this.state.member, member, loading: false, loadedOnce: true });
                },
                error: (err) => {
                    this.setState({ loading: false });
                    console.error(err);
                }
            });
            member$.connect();
        }

        reloadMember = () => {
            memberRefresh$.next();
            this.loadMember();
        }

        render() {
            const { member, loadedOnce, loading } = this.state;
            return <WrappedComponent member={member} memberLoadedOnce={loadedOnce} reloadMember={this.reloadMember} loadingMember={loading} {...this.props} />;
        }
    };
}

